/* eslint-disable react/prop-types */
import { border, Column, FlexItem, Row } from '@zipdrug/ui';
import { StyleSheet } from 'aphrodite/no-important';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PasswordExpirationWarning from '../password/PasswordExpirationWarning';
import Page from '../ui/Page';
import { setPatientId as setPatientIdAction } from '../redux/queryReducer';
import ActivityFeedContainer from './activity-feed/ActivityFeedContainer';
import PatientInfoContainer from './info/PatientInfoContainer';
import RxPrescriberGroupListContainer from './rx/RxPrescriberGroupListContainer';

const sx = StyleSheet.create({
  activityFeed: {
    ...border.build('left'),
    minWidth: '50rem',
    height: '100%',
  },
  column: {
    flex: 1,
  },
  rxColumn: {
    maxWidth: 'initial',
  },
  sidebar: {
    flex: 'none',
    width: '17vw',
    maxWidth: '32rem',
    minWidth: '20rem',
    height: '100%',
  },
  mainContainer: {
    height: '100%',
    width: '100vw',
  },
  patientInfoContainer: {
    height: '18vh',
  },
  activityContainer: {
    height: '78vh',
    maxHeight: '81vh',
  },
});

const PatientsPage = ({ selectedPatientId, setPatientId, ...props }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // 1) On hard reload: restore selected patient from URL param.
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const patientIdParam = urlParams.get('patient_id');
    const patientIdNumber = Number(patientIdParam);

    if (patientIdParam && Number.isInteger(patientIdNumber) && patientIdNumber > 0) {
      if (selectedPatientId !== patientIdNumber) {
        setPatientId(patientIdNumber);
      }
    }
  }, [location.search, setPatientId]);

  // 2) When navigating within the app: persist selected patient into the URL so refresh keeps context.
  useEffect(() => {
    if (!selectedPatientId) return;
    const urlParams = new URLSearchParams(location.search);
    const currentParam = Number(urlParams.get('patient_id'));

    if (!Number.isInteger(currentParam) || currentParam !== selectedPatientId) {
      urlParams.set('patient_id', String(selectedPatientId));
      navigate({ pathname: location.pathname, search: `?${urlParams.toString()}` }, { replace: true });
    }
  }, [location.pathname, location.search, navigate, selectedPatientId]);

  return (
    <Page direction="column">
      <FlexItem component={Column} styles={sx.mainContainer}>
        <PasswordExpirationWarning />
        <PatientInfoContainer styles={sx.patientInfoContainer} {...props} />
        <FlexItem component={Row} styles={sx.activityContainer}>
          <ActivityFeedContainer styles={[sx.activityFeed, sx.column]} />
          <RxPrescriberGroupListContainer styles={[sx.rxColumn, sx.column]} />
        </FlexItem>
      </FlexItem>
    </Page>
  );
};

const mapStateToProps = state => ({
  selectedPatientId: state?.query?.all?.patient_id || null,
});

const mapDispatchToProps = dispatch => ({
  setPatientId: patient_id => dispatch(setPatientIdAction({ patient_id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientsPage);
